import { useEffect, useState } from "react";
import { useUserProfile } from "@providers/profile";
import { Shopify } from "@models/shopify.model";
import Loading from "@components/ui/loading";
import PaymentStatusList from "./PaymentStatusList";
import PaymentList from "./PaymentList";
import OrderDetail from "./OrderDetail";
import { initialPaymentState, PaymentHistoryProps, PaymentState } from "./PaymentHistory.model";
import { useOrders } from "@providers/order";
import { AccountSection } from "../Account.styled";

const PaymentHistory = ({
  isDigital,
  digitalDisclaimers,
  membershipModal,
}: PaymentHistoryProps) => {
  const [paymentState, setPaymentState] = useState<PaymentState>(initialPaymentState);
  const {
    getCharges,
    getInvoices,
    profileState: { profile, authToken, shopifyToken },
  } = useUserProfile();

  const { dispatch, getOrders } = useOrders();

  useEffect(() => {
    setPaymentState({ ...paymentState, loading: true });

    async function fetchPayments() {
      const [charges, invoices, orders] = await Promise.all([
        await getCharges(authToken),
        await getInvoices(authToken),
        await getOrders(shopifyToken, dispatch),
      ]);

      setPaymentState({
        ...paymentState,
        charges,
        invoices,
        orders,
        loading: false,
      });
    }

    fetchPayments();
  }, []);

  const toggleOrderDetails = (order: Shopify.Order | null) => {
    setPaymentState({ ...paymentState, displayOrderDetail: order });
  };

  return paymentState.displayOrderDetail ? (
    <>
      <OrderDetail
        order={paymentState.displayOrderDetail}
        membershipModal={membershipModal}
        toggleOrderDetails={toggleOrderDetails}
      />
    </>
  ) : (
    <AccountSection>
      <PaymentList
        isDigital={isDigital}
        digitalDisclaimer={digitalDisclaimers?.general_disclaimer}
        orders={paymentState.orders}
        invoices={paymentState.invoices}
        toggleOrderDetails={toggleOrderDetails}
      />
      <PaymentStatusList
        isDigital={isDigital}
        digitalDisclaimer={digitalDisclaimers?.payment_status_disclaimer}
        charges={paymentState.charges}
      />
      <Loading visible={paymentState.loading} />
    </AccountSection>
  );
};

export default PaymentHistory;
